// extracted by mini-css-extract-plugin
module.exports = {"qrContainer":"download-qrcode_qrContainer_3NKb1","deviceInfo":"download-qrcode_deviceInfo_1r7FQ","qrCode":"download-qrcode_qrCode_5SmRS"};